// Vuelidate 0.x `sameAs('field')` compatible validator for Vuelidate 2
export const sameAsField = field => (value, siblings, vm) => {
  const source = siblings && field in siblings ? siblings : vm
  return value === (source ? source[field] : undefined)
}
